export default __webpack_public_path__ + "static/media/github.bb7ad8ab.svg";